module.exports = __webpack_public_path__ + "img/h54img3.2ca1ed53.png";